
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { KEYBOARD_SHORTCUTS } from "@/lib/keyboard-shortcuts/global-shortcuts";

@Component({
  components: {}
})
export default class KeyboardShortcutsHelpModal extends Vue {
  @Prop()
  open!: boolean;

  get keyboardShortcuts() {
    return KEYBOARD_SHORTCUTS;
  }

  getKeyboardShortcutValue(keys: string[]) {
    const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    let keyCombo = keys ? keys[0] : "";
    if (!isMacLike && keys.length == 2) {
      keyCombo = keys[1];
    }

    return keyCombo.toUpperCase().split("+").join(" + ");
  }
}
